import { REFERRAL_COUNT, REFERRAL_SUM } from '../../constants';
import { api } from '../api';
import { GetReferralSumResponse, GetReferralCountResponse } from './types';

export const referralSlice = api.injectEndpoints({
  endpoints: (build) => ({
    referralCount: build.query<GetReferralCountResponse, void>({
      query: () => `${REFERRAL_COUNT}`
    }),
    referralSum: build.query<GetReferralSumResponse, void>({
      query: () => `${REFERRAL_SUM}`
    })
  }),

  overrideExisting: false
});

export const { useReferralCountQuery, useReferralSumQuery } = referralSlice;
